import { render, staticRenderFns } from "./RecruitmentDetail.vue?vue&type=template&id=e7841092&scoped=true&"
import script from "./RecruitmentDetail.vue?vue&type=script&lang=js&"
export * from "./RecruitmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentDetail.vue?vue&type=style&index=0&id=e7841092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7841092",
  null
  
)

export default component.exports